var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgOpenMenu = function SvgOpenMenu(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    fill: "none",
    viewBox: "0 0 15 14",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0c2632",
    d: "M7.603 5.072v3.856q0 .24.22.332a.33.33 0 0 0 .39-.076l1.689-1.69A.68.68 0 0 0 10.114 7a.68.68 0 0 0-.212-.495l-1.69-1.69a.33.33 0 0 0-.388-.075.33.33 0 0 0-.22.332M1.663 14q-.587 0-1-.413a1.36 1.36 0 0 1-.413-1V1.413q0-.587.413-1a1.36 1.36 0 0 1 1-.413h11.173q.588 0 1.001.413t.413 1v11.173q0 .588-.413 1.001a1.36 1.36 0 0 1-1 .413zm2.087-.875V.875H1.664a.52.52 0 0 0-.37.168.52.52 0 0 0-.169.37v11.173q0 .203.168.37a.52.52 0 0 0 .37.169zm.875 0h8.211a.52.52 0 0 0 .37-.168.52.52 0 0 0 .169-.37V1.413a.52.52 0 0 0-.168-.37.52.52 0 0 0-.37-.169H4.624z"
  })));
};
export default SvgOpenMenu;